import {
  ActionButton,
  ButtonColumn,
  DateColumn,
  IconColumn,
  TableConfig,
  TextColumn,
} from 'ngx-eo-web-components';
import { TableConfigBuilder } from '../../core/interfaces/ITableConfig';
import { UsersTableConfigBuilder } from '../../user/config/user-search.config';
import { HospitalAvailability } from '../../core/models/hospital-availability.model';
import { AuthService } from '../../../services/auth/auth.service';

export class HospitalAvailabilitiesTableConfigBuilder extends TableConfigBuilder<HospitalAvailability> {
  private hospitalAvailabilityDeleteFunc:
    | ((hospitalAvailabilityId: string, event?: any) => void)
    | undefined;

  private authService: AuthService;

  constructor(authService: AuthService) {
    super();
    this.authService = authService;
  }

  private isPrivateHospitalAdmin(): boolean {
    return this.authService?.hasRoles(['PrivateHospitalAdmin']) ?? false;
  }

  getColumns() {
    if (this.getFunction('onEditHospitalAvailability') == undefined) {
      return [];
    }

    const columns = [
      new TextColumn({
        name: 'Μήνας',
        propertyName: 'availabilityMonthText',
      }),
      new TextColumn({
        name: 'Έτος',
        propertyName: 'availabilityYear',
      }),
      new TextColumn({
        name: 'Αριθμός Χειρουργείων',
        propertyName: 'slots',
      }),
      new DateColumn({
        name: 'Ημ. Δημιουργίας',
        propertyName: 'dateInserted',
      }),
      new DateColumn({
        name: 'Ημ. Τροποποίησης',
        propertyName: 'dateModified',
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-pencil p-warning',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Επεξεργασία Διαθεσιμότητας',
          tooltipPosition: 'bottom',
        },
        action: (item) => {
          this.getFunction('onEditHospitalAvailability', item);
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-trash p-danger',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Διαγραφή Διαθεσιμότητας',
          tooltipPosition: 'bottom',
        },
        action: (item?: HospitalAvailability, event?: any) => {
          if (this.hospitalAvailabilityDeleteFunc) {
            this.hospitalAvailabilityDeleteFunc(item?.id ?? '', event);
          }
        },
      }),
    ];

    if (this.isPrivateHospitalAdmin()) {
      columns.unshift(
        new TextColumn({
          name: 'Κλινική',
          propertyName: 'clinicName',
        })
      );
    }

    return columns;
  }

  getTable(data: HospitalAvailability[]): TableConfig<HospitalAvailability> {
    this.setTitle('')
      .setColumns(this.getColumns())
      .setTableData(data)
      .setLineNumbers(true);

    return this.getTableConfig();
  }

  addHospitalAvailabilityDeleteFunction(
    hospitalAvailabilityDeleteFunc: (
      hospitalAvailabilityId: string,
      event?: any
    ) => void
  ): HospitalAvailabilitiesTableConfigBuilder {
    this.hospitalAvailabilityDeleteFunc = hospitalAvailabilityDeleteFunc;
    return this;
  }
}
